import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import styles from './filter-date-range.scss';
import { RadioSymbol } from 'ui';
import { OptionsType } from 'ui/common/select/types';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { OptionTypes, FilterOption, ConditionValuesOperator } from 'app/components/filters/types';
import { FilterOptionType } from 'app/area/filters/types';

export interface FilterDateRangeProps extends FilterCommonProps {
  onFilterOptionType: (filterOption: FilterOption, filterOptionType: FilterOptionType) => void;
}

export class FilterDateRange extends React.Component<FilterDateRangeProps> {
  private handleOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const selectedOption = Number(e.currentTarget.value);

    this.props.onFilterOptionType({
      id: this.props.filterDomain.id,
      type: selectedOption
    }, FilterOptionType.OPTION_TYPE);
  };

  private renderFixedPeriod = () => {
    const { optionsEndpoint, simpleFormComponent: SimpleForm, initialValue, filterDomain: { id: name, optionType } } = this.props;
    const selected = optionType !== OptionTypes.NotSpecified && optionType !== OptionTypes.SpecificPeriodRange;
    const fixedPeriodValue = initialValue && initialValue.find(item => !!item && item.type === OptionTypes.FixedPeriod);

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-fixed-period`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.FixedPeriod}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-fixed-period`}
        className="form-check-label">
        <RadioSymbol />
        <b>{this.props.translation.filters_date_range_date_fixed_period}</b>
      </label>

      {selected && <SimpleForm
        name={name + customFilterFieldPostfix.fixedPeriod}
        type={FIELD_TYPE.SELECT_SINGLE}
        initialValue={fixedPeriodValue && { value: fixedPeriodValue.value, description: fixedPeriodValue.description }}
        optionsEndpoint={optionsEndpoint}
        optionsDisplaySetting={OptionsType.flat}
        readOnly={!selected}
        placeholder={this.props.translation && this.props.translation.filters_search_placeholder}
        translation={this.props.translation}
      />}
    </div>;
  };

  private renderSpecificPeriod = () => {
    const { simpleFormComponent, initialValue, filterDomain: { id: name, optionType, conditions } } = this.props;
    const specificPeriodValue = initialValue
      && initialValue.findIndex(f => !!f && f.type === OptionTypes.SpecificPeriodRange) > -1 && initialValue;
    const conditionOperator = !!conditions?.length && conditions[0].values[0]?.operator.v;
    const hasValueForOnlyDateTo = specificPeriodValue &&
      specificPeriodValue[0] && conditions[0].values.length === 1 && conditionOperator === ConditionValuesOperator.less;
    const initialValueFrom = !hasValueForOnlyDateTo ?
      specificPeriodValue && specificPeriodValue[0] && parseAsDateUTC(specificPeriodValue[0].value) : undefined;
    const initialValueTo = hasValueForOnlyDateTo ?
      parseAsDateUTC(initialValue[0].value) : specificPeriodValue && specificPeriodValue[1] && parseAsDateUTC(specificPeriodValue[1].value);

    //eslint:disable-next-line
    const SimpleForm = simpleFormComponent;
    const selected = optionType === OptionTypes.SpecificPeriodRange;
    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-range`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.SpecificPeriodRange}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-range`}
        className="form-check-label">
        <RadioSymbol />
        <b>{this.props.translation.filters_date_range_date_interval}</b>
      </label>

      {selected && <div className={styles.dateGroup}>
        <div>
          <label>{this.props.translation.filters_date_range_from}</label>
          <SimpleForm
            name={name + customFilterFieldPostfix.dateIntervalFrom}
            type={FIELD_TYPE.DATE_TIME}
            initialValue={initialValueFrom}
            readOnly={!selected}
          />
        </div>
        <div>
          <label>{this.props.translation.filters_date_range_to}</label>
          <SimpleForm
            name={name + customFilterFieldPostfix.dateIntervalTo}
            type={FIELD_TYPE.DATE_TIME}
            initialValue={initialValueTo}
            readOnly={!selected}
          />
        </div>
      </div>}
    </div>;
  };

  private renderNotSpecified = () => {
    const { simpleFormComponent, translation, filterDomain: { id: name, optionType } } = this.props;
    const SimpleForm = simpleFormComponent;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-not-specified`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.NotSpecified}
        checked={optionType === OptionTypes.NotSpecified}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-not-specified`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p>{translation.filters_not_specified_subtitle}</p>
        </div>
        {optionType === OptionTypes.NotSpecified
          && <div className="d-none">
            <SimpleForm
              name={name + customFilterFieldPostfix.notSpecified}
              type={FIELD_TYPE.SELECT_SINGLE}
              initialValue={{ description: translation.filters_not_specified_title }}
            />
          </div>}
      </label>
    </div>;
  };

  public render() {
    return <div>
      {this.renderFixedPeriod()}
      {this.renderSpecificPeriod()}
      {this.renderNotSpecified()}
    </div>;
  }
}
